import { fromJS } from "immutable";
import * as types from "../constants";

const defaultState = fromJS({
  countProduct: "",
  proccessing: "",
  countAllReview: 0,
});

let result = "";

const importFile = (state = defaultState, action) => {
  switch (action.type) {
    case types.IMPORT_FILE_EXCEL:
      return state;

    case types.IMPORT_FILE_EXCEL_RESULT:
      result = action.payload;
      return state.set("proccessing", result);

    case types.GET_COUNT_TOTAL_PRODUCT_RESULT:
      result = action.payload.count;
      return state
        .set("countProduct", result)
        .set("countAllReview", action.payload.count_all_review);

    default:
      return state;
  }
};

export default importFile;
